import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  template: `
    <div class="modal-header">
      <h4 class="modal-title" id="delete-assessment-title">
        {{ 'rspDeleteDialogTitle' | translate }}
      </h4>
      <button
        type="button"
        class="btn-close"
        [attr.aria-label]="'rspModalCloseButtonAriaLabel' | translate"
        (click)="activeModal.dismiss()"
      ></button>
    </div>
    <div class="modal-body" id="delete-assessment-body">
      {{ 'rspDeleteDialogBody' | translate }}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark modal-dismiss" (click)="activeModal.dismiss()">
        {{ 'rspLanguageWarningButtonCancel' | translate }}
      </button>
      <button type="button" class="btn btn-outline-dark modal-close" (click)="activeModal.close('delete')">
        {{ 'rspDeleteDialogDelete' | translate }}
      </button>
    </div>
  `,
  imports: [TranslateModule],
})
export class DeleteAssessmentModalComponent {
  constructor(public activeModal: NgbActiveModal) {}
}
